// Naslouchá zprávám z legacy single-form iframů a napojuje je na okenní framework:
//   - `window/chrome` → uloží titulek + akce do chrome storu (klíč = layerId)
//   - `window/focus`  → přenese stack daného okna do popředí (klik uvnitř iframu)
// Korelace zprávy → Phoenix okno přes registr okno↔layerId. Mountuje se v PhoenixDesktop.

import { useEffect } from 'react';

import {
  legacyFormSourceRegistry,
  MAGIC_TO_PHOENIX_ACTIONS,
  type WindowChromeData,
} from '@/shared/legacyMagicBridge';
import { updateAgendaHistoryTitleForLayer } from '@/shared/lib/agendaHistory';

import { useWindowingActions } from '../desktop/useWindowingActions';

import { useLegacyWindowChromeStore } from './legacyWindowChromeStore';

export function useLegacyWindowChrome(): void {
  const setChrome = useLegacyWindowChromeStore((s) => s.set);
  const actions = useWindowingActions();

  useEffect(() => {
    function handle(event: MessageEvent) {
      const raw = event.data as { action?: string; data?: unknown } | null | undefined;
      if (!raw || typeof raw.action !== 'string') return;
      const source = event.source as Window | null;
      if (!source) return;

      if (raw.action === MAGIC_TO_PHOENIX_ACTIONS.windowChrome) {
        const layerId = legacyFormSourceRegistry.resolveLayerId(source);
        if (!layerId) return;
        const data = (raw.data ?? { title: '', actions: [] }) as WindowChromeData;
        setChrome(layerId, data);
        // Po načtení okna je znám jeho titulek → doplň ho do navázaného záznamu historie
        // (přepíše původní identifikátor).
        if (data.title) updateAgendaHistoryTitleForLayer(layerId, data.title);
      } else if (raw.action === MAGIC_TO_PHOENIX_ACTIONS.windowFocus) {
        const layerId = legacyFormSourceRegistry.resolveLayerId(source);
        if (layerId) actions.focus(layerId);
      }
    }

    window.addEventListener('message', handle);
    return () => window.removeEventListener('message', handle);
  }, [setChrome, actions]);
}
